/*
 * File: PatientDemographicFieldsList.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays patient demographics fields
 */
import React from "react";
import { List } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import PatientPropertyList from "services/patients/components/PatientPropertyList";
import PropTypes from "prop-types";

const styles = theme => ({
  root: {
    position: "relative",
    width: "100%"
  },
  editBtn: {
    position: "absolute",
    bottom: theme.spacing(1.5),
    left: "50%",
    marginLeft: theme.spacing(-5),
    zoom: 0.7
  }
});

/**
 * Render the fields list and the edit button
 * @prop classes is a css class
 * @prop toggleEditPatient is the method that determines whether the edit patient dialog is open
 * @prop patient is the patient to display in the demographics
 */
const PatientDemographicFieldsList = ({ classes, patient }) => {
  return (
    <div className={classes.root}>
      <List>
        {patient && (
          <PatientPropertyList person={patient} guarantorView={false} />
        )}
      </List>
    </div>
  );
};

PatientDemographicFieldsList.propTypes = {
  classes: PropTypes.object.isRequired,
  patient: PropTypes.object
};

export default withStyles(styles)(observer(PatientDemographicFieldsList));
